import React from "react";
import { MediaFeature, MediaSide } from "./MediaFeature";
import ProfilesImg from "../../../images/pricing/profiles.png";

export const SmartLearningFeature: React.FC<{ mediaSide?: MediaSide }> = ({
  mediaSide = "right",
}) => (
  <MediaFeature
    header={
      <>
        <div className="flex flex-row">
          <span>Get ahead with</span>
        </div>
        <span className="text-purple-600">smart learning profiles</span>
        <br />
      </>
    }
    body={
      <>
        Ace your exams with our new spaced-repetition profiles optimized for
        exam study, learning languages, or anything else you want to use Zorbi
        for.
        <br />
        <br />
        We've designed these profiles based on learning data from thousands of
        users. You&apos;ll also be the first to get access to our AI learning
        assistant.
        <br />
        <br />
      </>
    }
    disableMediaShadow={true}
    media={
      <div className="w-full">
        <img
          src={ProfilesImg}
          className="max-w-xs mx-auto rounded-lg sm:max-w-lg bg-plainGray-500 sm:p-1"
        />
      </div>
    }
    mediaSide={mediaSide}
  />
);
